import { Plan, DeliveryTime, Language, Testimonial, SocialLink } from './types';

export const PLANS: Record<string, Plan> = {
  basic: {
    title: 'الباقة الأساسية',
    features: ['سيرة ذاتية احترافية', 'تنسيق متوافق مع ATS', 'تعديلين مجانيين'],
    basePrice: {
      experienced: {
        singleLanguage: 140,
        bothLanguages: 180
      },
      freshGraduate: {
        singleLanguage: 100,
        bothLanguages: 140
      }
    }
  },
  professional: {
    title: 'الباقة الاحترافية',
    features: ['سيرة ذاتية احترافية', 'خطاب تقديمي', 'تنسيق متوافق مع ATS', '3 تعديلات مجانية'],
    basePrice: {
      experienced: {
        singleLanguage: 170,
        bothLanguages: 210
      },
      freshGraduate: {
        singleLanguage: 120,
        bothLanguages: 160
      }
    }
  },
  comprehensive: {
    title: 'الباقة الشاملة',
    features: [
      'سيرة ذاتية احترافية',
      'خطاب تقديمي',
      'تحسين ملف LinkedIn',
      'تنسيق متوافق مع ATS',
      'تعديلات غير محدودة'
    ],
    basePrice: {
      experienced: {
        singleLanguage: 200,
        bothLanguages: 240
      },
      freshGraduate: {
        singleLanguage: 145,
        bothLanguages: 185
      }
    }
  }
};

export const DELIVERY_TIMES: DeliveryTime[] = [
  { days: 0.25, label: 'تسليم خلال 6 ساعات', price: 80 },
  { days: 0.5, label: 'تسليم خلال 12 ساعة', price: 60 },
  { days: 1, label: 'تسليم خلال 24 ساعة', price: 40 },
  { days: 3, label: 'تسليم خلال 3 أيام', price: 0 },
  { days: 5, label: 'تسليم خلال 5 أيام', price: -10 }
];

export const LANGUAGES: Language[] = [
  { id: 'englishOnly', label: 'إنجليزي فقط', price: 0 },
  { id: 'arabicOnly', label: 'عربي فقط', price: 0 },
  { id: 'both', label: 'عربي وإنجليزي', price: 40 }
];

export const SOCIAL_LINKS: SocialLink[] = [
  { 
    platform: 'tiktok', 
    url: 'https://www.tiktok.com/@top_serah?_t=ZS-8uuRFlw87Tb&_r=1', 
    icon: 'Music2' 
  },
  { 
    platform: 'x', 
    url: 'https://x.com/topserah?s=21', 
    icon: 'Twitter' 
  },
  { 
    platform: 'instagram', 
    url: 'https://www.instagram.com/top_serah?igsh=MTFsMHF6OHJwemd2cg%3D%3D&utm_source=qr', 
    icon: 'Instagram' 
  },
  { 
    platform: 'facebook', 
    url: 'https://www.facebook.com/share/1DuCfVeqtV/?mibextid=wwXIfr', 
    icon: 'Facebook' 
  }
];

export const FAQ_ITEMS = [
  {
    question: 'كم يستغرق إعداد السيرة الذاتية؟',
    answer: 'يعتمد وقت التسليم على الخيار الذي تختاره. نقدم خيارات متعددة تتراوح من 6 ساعات إلى 5 أيام. كلما كان وقت التسليم أسرع، زاد السعر.'
  },
  {
    question: 'ما هي سياسة التعديلات؟',
    answer: 'تختلف عدد التعديلات المجانية حسب الباقة المختارة. الباقة الأساسية تشمل تعديلين، الباقة الاحترافية 3 تعديلات، والباقة الشاملة تعديلات غير محدودة.'
  },
  {
    question: 'لماذا أحتاج خطاب تقديمي؟',
    answer: 'الخطاب التقديمي يعزز فرصك في الحصول على المقابلة بنسبة تصل إلى 50٪. إنه يوضح مهاراتك وخبراتك بشكل مفصل ويظهر اهتمامك بالوظيفة.'
  },
  {
    question: 'ما أهمية تحسين ملف LinkedIn؟',
    answer: 'يزيد تحسين ملف LinkedIn من ظهورك في نتائج البحث للموظفين، ويحسن فرص التواصل المهني، ويزيد من فرص العثور على وظيفة بنسبة تصل إلى 40٪.'
  }
];

export const VALID_DISCOUNT_CODES = ['Ramadan40', 'Eid40'];